import React from 'react';
import { User, Mail, Phone } from 'lucide-react';

/**
 * One-line customer line for compact admin cards.
 * Renders: 👤 Name [Member|Guest] · ✉ email · ☎ phone
 */
export default function CustomerInfoInline({ customer, testId }) {
  if (!customer) return null;
  return (
    <div
      className="flex items-center gap-x-3 gap-y-1 text-sm flex-wrap"
      data-testid={testId || 'customer-info-inline'}
    >
      <span className="inline-flex items-center gap-1.5 font-semibold text-gray-900">
        <User className="w-4 h-4" />
        {customer.name}
        <span className="text-[10px] px-1.5 py-0.5 bg-primary/10 text-primary rounded-full font-bold uppercase">
          {customer.type}
        </span>
      </span>
      {customer.email && customer.email !== 'N/A' && (
        <span className="inline-flex items-center gap-1 text-gray-600">
          <Mail className="w-3.5 h-3.5" />
          <span className="truncate max-w-[200px]">{customer.email}</span>
        </span>
      )}
      {customer.phone && customer.phone !== 'N/A' && (
        <span className="inline-flex items-center gap-1 text-gray-600">
          <Phone className="w-3.5 h-3.5" />
          {customer.phone}
        </span>
      )}
    </div>
  );
}
